import { useAuth } from "react-oidc-context";
export function useAccessToken(): string | undefined {
    return useAuth().user?.access_token;
}
